import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Modal,
  Backdrop,
  Fade,
  Typography,
  Button as MuiButton,
} from "@material-ui/core";
import { Divider, Stack, Box, ButtonBase } from "@mui/material";
import Button from "../Button";
import MuiTooltip from "../MuiTooltip";
import CloseIcon from "@mui/icons-material/Close";
import TextView from "../TextView";
import { colors } from "../../utils";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 2, 3),
    width: "30%",
    maxHeight: "80%",
    overflowY: "auto",
    borderRadius: 10,
  },
}));

const ModalWrapper = ({
  isOpen,
  handleClose,
  onSubmit = () => {},
  isCancelButtonVisible = true,
  iconKey = "warning",
  title = "",
  tooltipMessage = null,
  children,
  buttonText = "",
  cancelButtonText = "Cancel",
  repeatButtonText = null,
  onRepeat = () => {},
  prefixIcon,
  buttonLoading,
  onCencelButtonPress,
}) => {
  const classes = useStyles();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      className={classes.modal}
      open={isOpen}
      // onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <div className={classes.paper}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="center">
              {React.isValidElement(prefixIcon) ? (
                prefixIcon
              ) : (
                <img
                  src={prefixIcon}
                  height={32}
                  width={32}
                  style={{ marginRight: "8px" }}
                  alt="clone"
                />
              )}
              <Typography
                variant="h6"
                id="transition-modal-title"
                style={{
                  color: colors.black,
                  fontFamily: "DM Sans",
                  fontWeight: 700,
                  fontSize: "20px",
                  lineHeight: "20px",
                  marginRight: "5px",
                }}
              >
                {title}
              </Typography>

              {tooltipMessage && (
                <MuiTooltip
                  message={tooltipMessage}
                  size="medium"
                  sx={{ marginTop: 0.5 }}
                />
              )}
            </Box>

            <div onClick={handleClose}>
              <CloseIcon />
            </div>
          </Stack>

          <Divider sx={{ mt: 2 }} variant="middle" />
          {children}

          {/* Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              alignItems: "center",
              mt: 3,
            }}
          >
            {isCancelButtonVisible && (
              <ButtonBase onClick={onCencelButtonPress ?? handleClose}>
                <TextView variant="subtitle">{cancelButtonText}</TextView>{" "}
              </ButtonBase>
              // <MuiButton
              //   color='primary'
              //   variant='text'
              //   onClick={() => handleClose()}
              // >
              //   {cancelButtonText}
              // </MuiButton>
            )}
            {repeatButtonText && (
              <Button
                style={{ width: "auto" }}
                variant="outlined"
                onClick={() => onRepeat()}
              >
                {repeatButtonText}
              </Button>
            )}
            <Box>
              <Button
                isLoading={buttonLoading}
                onClick={() => onSubmit()}
                sx={{ mt: 10 }}
                style={{ minWidth: 130 }}
              >
                {buttonText}
              </Button>
            </Box>
          </Box>
        </div>
      </Fade>
    </Modal>
  );
};

export default ModalWrapper;
